import { routes as Main } from './Main';

export default [
    ...Main
];



// WEBPACK FOOTER //
// ./src/app/routes.js